module.exports = __webpack_public_path__ + "static/img/pay-8.3f29745.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay/pay-8.png
// module id = IV6M
// module chunks = 1